// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Comment Lines, Removed unused service
// MODIFIED DATE: 25-09-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/****************  GET CLOSED LOAN DETAILS LIST START *********************** */
export const closedloanDetailsListGet = (listData: any) => {
	const data = {
		GetMemberClosedLoanToken: listData,
	};
	const url = `${API_URL}postAllClosedLoanDetails`;
	return makeApiCall(url, data);
};
/****************  GET CLOSED LOAN DETAILS LIST END *********************** */
